
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as newUR__kIgCCDdzG7WwFsZKiau0CihtBFHB1mk5wYq5yIAMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/new.vue?macro=true";
import { default as logHCRt4KVi3uL1fRDa4c_mHle423e7zZ7UDQa_jBwo8sIMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/log.vue?macro=true";
import { default as flagsJrPmm3OQ_ef4ojBLvJcoe101lW76HfW3zmhyxZd7qwoMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/flags.vue?macro=true";
import { default as statsbx2nxW7jtgigpFsxJFW_8BZ934XQ36yOzQXraUMNwD8Meta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/stats.vue?macro=true";
import { default as healthL0youYCPdLsTYOaDXuAi_TqbgmUie4rUcN_lbYlbH9YMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/health.vue?macro=true";
import { default as settings9kBR2QrZR_iYNStVgbGi_gmaLIVooHrV90lhOifEJEEMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/settings.vue?macro=true";
import { default as indexA8hEyRXiYFglbZ5qL1p_akK_n1rR5icWue1xDFarKQoMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/user/index.vue?macro=true";
import { default as _91user_93pufyjJuuavgd7J3ofWsQComL0VBpAAPGsbT3TzgNAccMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/user/[user].vue?macro=true";
import { default as _91user_9307_ScnVYPQMyAPzPY8w2Dtl8FEykrK7mPiLJ4UbJVaoMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/activities/[user].vue?macro=true";
import { default as projectst3wcEMyc3fKkSDLvPn_mbCPI0568SFVsHYxLH4moI_4Meta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/approval/projects.vue?macro=true";
import { default as versionsGe70E0Z1RJ253W22fQ8Ubaj0prTVa0emMS5GVe_YF_gMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/approval/versions.vue?macro=true";
import { default as adminh4PghuIxgGPzFWb4eQ05j0tyFkT6zP9Qn9LF73jbvGIMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/admin.vue?macro=true";
import { default as errorsK7VdENMSb6sjnl1om8dJscsWX6MfRnBpPnu5dFLG1EMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/error.vue?macro=true";
import { default as indexW0kpMbJW4K5P0R9RQA_gIdsq8g64Y9JQWkNZSzHo_ksMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/index.vue?macro=true";
import { default as paperrBotvvXOAcUbD2kjSRxDDLqtRLd7lORCx7Pj_X5uLHUMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/paper.vue?macro=true";
import { default as staffEnEreq3Gvioendv0ch_xK0Rkl7bQWBGeWAjsAXqtP5gMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/staff.vue?macro=true";
import { default as termsJWB34QwGCpFlBrO2_Pc5mWdbcAX8ASEddexamKWBsekMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/terms.vue?macro=true";
import { default as indexusV9Wm9jE9b01RYV_g4ztCBCtpxG9KZWmXvamdaRmPIMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/index.vue?macro=true";
import { default as flagsBgi9kXHytHDgnZ38tq_3Odf9YjlcDN0DsXTO1NIEmoUMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/flags.vue?macro=true";
import { default as indexb410FeEgZJ5W_PrrTTth_WtVGyF6fXoD1CyuyKkmNccMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/index.vue?macro=true";
import { default as notese2mZCx__JLK5Q2zHv9MwdzhpjmZ2oHmFMCLI4ej8a_EMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/notes.vue?macro=true";
import { default as starsx3GPkWkI9Kv2EnpwsYoI_QFLAoNoCHb1Sp6Cc_K0fu8Meta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/stars.vue?macro=true";
import { default as discussx0OtuWSkVjjVtR6gB7Rpd3QGiorrjE9F2YGa_BA3VfAMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/discuss.vue?macro=true";
import { default as channelsNtomkea7JPan8DDYzGcx_qwc4QuoilxlcAGXB00HQF8Meta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/channels.vue?macro=true";
import { default as watchers_4FulzAnqvN945Zgbgc1Mni6AUY5GNDusviWy9aItmsMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/watchers.vue?macro=true";
import { default as newCm46k549wXlooo6m56y_DDUuQhztWZrjKLHrUI7HwIsMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/new.vue?macro=true";
import { default as index9FjF4O3fOVtPgcJtX0_sRBbgxA3LSctmP_ap3qaHcwoMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/index.vue?macro=true";
import { default as _91_46_46_46page_93RLV8N3CCR579lO7den0aZP5qBELX_jHolC3PeVSo208Meta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/pages/[...page].vue?macro=true";
import { default as _91_46_46_46slug_9312h5ukafQKTjVXFt17fHEbM9v6mNWgEw4GYpb6fd2LYMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/settings/[...slug].vue?macro=true";
import { default as scan936YamNZLxyFa4GY34UsMf2Ri8ujXUv3HGJJR2qPWPEMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/[version]/scan.vue?macro=true";
import { default as indexxpBFA3WOXWqYGQei9uqR9S5xUKnPvyAi_7EaVPBeyoUMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/[version]/index.vue?macro=true";
import { default as reviews0Th25VWOJ1zcDznXNu1C_Cw_2UgzEosDuV0snb7DidAMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/[version]/reviews.vue?macro=true";
import { default as _91version_937S9tpiT0cWo3wSmtovwPHHO8T2_dQkuQi5qfVOHMvtYMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/[version].vue?macro=true";
import { default as _91project_93Ea_p6DPqC4jYB627iKPH55LLMBAxoaAn_4_0F5G_aIIMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project].vue?macro=true";
import { default as _91user_93Pw0OUSlyhQOJZGdje4NbJ1CxvAocmlzcomosAnYrSSgMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/[user].vue?macro=true";
import { default as authorsumg9NtLHrArB4OuuTwaUYAeyAU3OJknSW4_undjl6PAMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/authors.vue?macro=true";
import { default as linkoutoJogMZPhog9hwS2XXxvAygNeo09mwjbJ7AfLIfozqUcMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/linkout.vue?macro=true";
import { default as privacylZ3tjupbXEmpibfnjpBRrSRsw7_kmzzo4Gckw_j0DmsMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/privacy.vue?macro=true";
import { default as versionyFTok5wlqi_fSmOe4yOtbpoBrwFqLT7oXRGSXOxxfCQMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/version.vue?macro=true";
import { default as api_45docs6_lxZoozpkfa5C8_f3tlNsMpdL0sWBih3GVjKl5vPXcMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/api-docs.vue?macro=true";
import { default as velocityYdthk9ik4MvfZ51OTJEdn8L_fpDn62_6WqHxUqs8fBwMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/velocity.vue?macro=true";
import { default as waterfall8Nhejf1HMPxIsdBRE7So_KdmDFSt4CbLz_xH_8iYfq4Meta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/waterfall.vue?macro=true";
import { default as loginDc8g9RuqfFR4aQ_8pk1Jjb9A_FmeWL8CJkVpWNNcs2EMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/login.vue?macro=true";
import { default as reset9fGm0HOOKawPDaE9gvPDq5bm7Y2r_AWdViIw8CyWsQYMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/reset.vue?macro=true";
import { default as guidelinesnv7OT7HkWW3pNwtqeahrtJ3U9f6rLd_HO19S3lELZgkMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/guidelines.vue?macro=true";
import { default as onboardingQ_iw2gziQnckM0mmGaDZThS6_a8717Ti6EIlsFa80jAMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/onboarding.vue?macro=true";
import { default as signupu_SzdGYY3m_fxVXIuSBriWJYqlEVXoLG1PeDFa1fj7EMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/signup.vue?macro=true";
import { default as bbcode2JsDLsnL4TFdidgbtjIq69OdB0YmCJxcjDTXBYBLGQwMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/tools/bbcode.vue?macro=true";
import { default as otherdLe9bvPcul5bSA83N3_RwjFk0Bj_xKZT_e3JCvxnwzYMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings/other.vue?macro=true";
import { default as accountjbDl9Acyd9s0h7v_f2kuZpxqIiDSnpTOYy_YOWBwtpYMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings/account.vue?macro=true";
import { default as profilemxRNi7WfO9v_18jGwwQsAEZ0VWWKNv9t_Wahn1JQqe8Meta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings/profile.vue?macro=true";
import { default as api_45keysdsl0Q8lQIQa42Oq_fT1jeFo_94Ux5_a_hddjnYjQMn0Meta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings/api-keys.vue?macro=true";
import { default as securityhmHZKXCBPGCIpmSTFF7YaHrI09PrxfnBFEYazEKMGWIMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings/security.vue?macro=true";
import { default as settingsiUsVlQmoqOXxpVWSWeNAjJs53th2nFj5K4vmAKyMTo8Meta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings.vue?macro=true";
import { default as notificationsZOnsMJErO7Zy6EZ4FqoOHx3y1yHjhnw4TPj0AZWYVIIMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/notifications.vue?macro=true";
import { default as importerKpFjr2G29KDMWokz1tSQcXjWM14iK_DBj_tTrdU0ApYMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/tools/importer.vue?macro=true";
import { default as markdowni7C7mSeRpdRTofUe55YbFLbPugmSVvb2BZMPvkFIJ0sMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/tools/markdown.vue?macro=true";
import { default as neworganizationqdYRd_HQD7Sy0pGU50hJHfhLeK5Ek6jdpNbkTqmydCMMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/neworganization.vue?macro=true";
import { default as oauth_45signupRznUNvAMiwJvR3tMoFSUcKct0zWv_NnT7DGd0B5_M0cMeta } from "/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/oauth-signup.vue?macro=true";
export default [
  {
    name: "new",
    path: "/new",
    meta: newUR__kIgCCDdzG7WwFsZKiau0CihtBFHB1mk5wYq5yIAMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/new.vue")
  },
  {
    name: "admin",
    path: "/admin",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/admin.vue"),
    children: [
  {
    name: "admin-log",
    path: "log",
    meta: logHCRt4KVi3uL1fRDa4c_mHle423e7zZ7UDQa_jBwo8sIMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/log.vue")
  },
  {
    name: "admin-flags",
    path: "flags",
    meta: flagsJrPmm3OQ_ef4ojBLvJcoe101lW76HfW3zmhyxZd7qwoMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/flags.vue")
  },
  {
    name: "admin-stats",
    path: "stats",
    meta: statsbx2nxW7jtgigpFsxJFW_8BZ934XQ36yOzQXraUMNwD8Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/stats.vue")
  },
  {
    name: "admin-health",
    path: "health",
    meta: healthL0youYCPdLsTYOaDXuAi_TqbgmUie4rUcN_lbYlbH9YMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/health.vue")
  },
  {
    name: "admin-settings",
    path: "settings",
    meta: settings9kBR2QrZR_iYNStVgbGi_gmaLIVooHrV90lhOifEJEEMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/settings.vue")
  },
  {
    name: "admin-user",
    path: "user",
    meta: indexA8hEyRXiYFglbZ5qL1p_akK_n1rR5icWue1xDFarKQoMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/user/index.vue")
  },
  {
    name: "admin-user-user",
    path: "user/:user()",
    meta: _91user_93pufyjJuuavgd7J3ofWsQComL0VBpAAPGsbT3TzgNAccMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/user/[user].vue")
  },
  {
    name: "admin-activities-user",
    path: "activities/:user()",
    meta: _91user_9307_ScnVYPQMyAPzPY8w2Dtl8FEykrK7mPiLJ4UbJVaoMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/activities/[user].vue")
  },
  {
    name: "admin-approval-projects",
    path: "approval/projects",
    meta: projectst3wcEMyc3fKkSDLvPn_mbCPI0568SFVsHYxLH4moI_4Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/approval/projects.vue")
  },
  {
    name: "admin-approval-versions",
    path: "approval/versions",
    meta: versionsGe70E0Z1RJ253W22fQ8Ubaj0prTVa0emMS5GVe_YF_gMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/admin/approval/versions.vue")
  }
]
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/index.vue")
  },
  {
    name: "paper",
    path: "/paper",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/paper.vue")
  },
  {
    name: "staff",
    path: "/staff",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/staff.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/terms.vue")
  },
  {
    name: _91user_93Pw0OUSlyhQOJZGdje4NbJ1CxvAocmlzcomosAnYrSSgMeta?.name,
    path: "/:user()",
    meta: _91user_93Pw0OUSlyhQOJZGdje4NbJ1CxvAocmlzcomosAnYrSSgMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user].vue"),
    children: [
  {
    name: "user",
    path: "",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/index.vue")
  },
  {
    name: _91project_93Ea_p6DPqC4jYB627iKPH55LLMBAxoaAn_4_0F5G_aIIMeta?.name,
    path: ":project()",
    meta: _91project_93Ea_p6DPqC4jYB627iKPH55LLMBAxoaAn_4_0F5G_aIIMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project].vue"),
    children: [
  {
    name: "user-project-flags",
    path: "flags",
    meta: flagsBgi9kXHytHDgnZ38tq_3Odf9YjlcDN0DsXTO1NIEmoUMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/flags.vue")
  },
  {
    name: "user-project",
    path: "",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/index.vue")
  },
  {
    name: "user-project-notes",
    path: "notes",
    meta: notese2mZCx__JLK5Q2zHv9MwdzhpjmZ2oHmFMCLI4ej8a_EMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/notes.vue")
  },
  {
    name: "user-project-stars",
    path: "stars",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/stars.vue")
  },
  {
    name: "user-project-discuss",
    path: "discuss",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/discuss.vue")
  },
  {
    name: "user-project-channels",
    path: "channels",
    meta: channelsNtomkea7JPan8DDYzGcx_qwc4QuoilxlcAGXB00HQF8Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/channels.vue")
  },
  {
    name: "user-project-watchers",
    path: "watchers",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/watchers.vue")
  },
  {
    name: "user-project-versions-new",
    path: "versions/new",
    meta: newCm46k549wXlooo6m56y_DDUuQhztWZrjKLHrUI7HwIsMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/new.vue")
  },
  {
    name: "user-project-versions",
    path: "versions",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/index.vue")
  },
  {
    name: "user-project-pages-page",
    path: "pages/:page(.*)*",
    meta: _91_46_46_46page_93RLV8N3CCR579lO7den0aZP5qBELX_jHolC3PeVSo208Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/pages/[...page].vue")
  },
  {
    name: "user-project-settings-slug",
    path: "settings/:slug(.*)*",
    meta: _91_46_46_46slug_9312h5ukafQKTjVXFt17fHEbM9v6mNWgEw4GYpb6fd2LYMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/settings/[...slug].vue")
  },
  {
    name: _91version_937S9tpiT0cWo3wSmtovwPHHO8T2_dQkuQi5qfVOHMvtYMeta?.name,
    path: "versions/:version()",
    meta: _91version_937S9tpiT0cWo3wSmtovwPHHO8T2_dQkuQi5qfVOHMvtYMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/[version].vue"),
    children: [
  {
    name: "user-project-versions-version-scan",
    path: "scan",
    meta: scan936YamNZLxyFa4GY34UsMf2Ri8ujXUv3HGJJR2qPWPEMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/[version]/scan.vue")
  },
  {
    name: "user-project-versions-version",
    path: "",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/[version]/index.vue")
  },
  {
    name: "user-project-versions-version-reviews",
    path: "reviews",
    meta: reviews0Th25VWOJ1zcDznXNu1C_Cw_2UgzEosDuV0snb7DidAMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/[user]/[project]/versions/[version]/reviews.vue")
  }
]
  }
]
  }
]
  },
  {
    name: "authors",
    path: "/authors",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/authors.vue")
  },
  {
    name: "linkout",
    path: "/linkout",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/linkout.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/privacy.vue")
  },
  {
    name: "version",
    path: "/version",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/version.vue")
  },
  {
    name: "api-docs",
    path: "/api-docs",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/api-docs.vue")
  },
  {
    name: "velocity",
    path: "/velocity",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/velocity.vue")
  },
  {
    name: "waterfall",
    path: "/waterfall",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/waterfall.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/login.vue")
  },
  {
    name: "auth-reset",
    path: "/auth/reset",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/reset.vue")
  },
  {
    name: "guidelines",
    path: "/guidelines",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/guidelines.vue")
  },
  {
    name: "onboarding",
    path: "/onboarding",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/onboarding.vue")
  },
  {
    name: "auth-signup",
    path: "/auth/signup",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/signup.vue")
  },
  {
    name: "tools-bbcode",
    path: "/tools/bbcode",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/tools/bbcode.vue")
  },
  {
    name: "auth-settings",
    path: "/auth/settings",
    meta: settingsiUsVlQmoqOXxpVWSWeNAjJs53th2nFj5K4vmAKyMTo8Meta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings.vue"),
    children: [
  {
    name: "auth-settings-other",
    path: "other",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings/other.vue")
  },
  {
    name: "auth-settings-account",
    path: "account",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings/account.vue")
  },
  {
    name: "auth-settings-profile",
    path: "profile",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings/profile.vue")
  },
  {
    name: "auth-settings-api-keys",
    path: "api-keys",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings/api-keys.vue")
  },
  {
    name: "auth-settings-security",
    path: "security",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/settings/security.vue")
  }
]
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsZOnsMJErO7Zy6EZ4FqoOHx3y1yHjhnw4TPj0AZWYVIIMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/notifications.vue")
  },
  {
    name: "tools-importer",
    path: "/tools/importer",
    meta: importerKpFjr2G29KDMWokz1tSQcXjWM14iK_DBj_tTrdU0ApYMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/tools/importer.vue")
  },
  {
    name: "tools-markdown",
    path: "/tools/markdown",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/tools/markdown.vue")
  },
  {
    name: "neworganization",
    path: "/neworganization",
    meta: neworganizationqdYRd_HQD7Sy0pGU50hJHfhLeK5Ek6jdpNbkTqmydCMMeta || {},
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/neworganization.vue")
  },
  {
    name: "auth-oauth-signup",
    path: "/auth/oauth-signup",
    component: () => import("/home/runner/work/Hangar/Hangar/frontend/app/pages/auth/oauth-signup.vue")
  }
]